import React, { useEffect, useState } from 'react';
import ServiceCard from './ServiceCard';
import useToken from '../context/useToken';
import axios from 'axios';

const OurService = () => {
  const token = useToken();
  const [services, setServices] = useState([]);

  // Array of services
  const fetchServices = async () => {
    try {
      const response = await axios.get('https://thecfagroup.org/v1/api/services', {
        headers: {
          'Accept': '*/*'
        }
      });
      
      // Assuming response.data contains an array of services
      setServices(response.data.services);
    } catch (error) {
      console.error('Error fetching services:', error);
    }
  };

  useEffect(() => {
    fetchServices();
  }, []);

  const [mainHeading, setMainHeading] = useState('Our Service');
  const [subHeading, setSubHeading] = useState(
    'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.'
  );

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://thecfagroup.org/v1/api/services/${id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': '*/*'
        }
      });
      
      // Update the local state only after successful deletion
      setServices(services.filter(service => service._id !== id));
      console.log(`Service with ID ${id} deleted successfully.`);
    } catch (error) {
      console.error('Error deleting service:', error);
    }
  };
  

  // States for managing modal and form input
  const [showServiceModal, setShowServiceModal] = useState(false);
  const [newService, setNewService] = useState({ title: '', description: '', headerImage: '' });
  const [imageFile, setImageFile] = useState(null); // State to store uploaded file
  const [showHeadingModal, setShowHeadingModal] = useState(false);

  // Function to handle image file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file); // Store the file directly
      setNewService({ ...newService, headerImage: file }); // Update newService with the file
    }
  };
  

  // Function to add a new service
  const handleAddService = async () => {
    const formData = new FormData();
    formData.append('title', newService.title);
    formData.append('subtitle', newService.subtitle);
    formData.append('description', newService.description);
    formData.append('isActive', true);
  
    if (imageFile instanceof File) {
      formData.append('iconImage', imageFile, imageFile.name || 'service-image.jpg');
    }
  
    try {
      await axios.post('https://thecfagroup.org/v1/api/services', formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
  
      setShowServiceModal(false);
      setNewService({ title: '', subtitle: '', description: '' });
      setImageFile(null);
      fetchServices(); // Refresh the services list
    } catch (error) {
      console.error('Error adding service:', error);
    }
  };
  

  return (
    <div>
      {/* Main Heading and Subheading */}
      <div className="flex flex-col items-center justify-center h-screen max-h-[50vh] text-center">
        <h2 className="text-[60px] flex items-center gap-10 text-[#1f1f25] font-bold mb-2">
          {mainHeading}
          {token && (
            <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="h-14 w-14 cursor-pointer text-gray-500 hover:text-gray-700"
            onClick={() => setShowHeadingModal(true)}
          >
            <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32l8.4-8.4Z" />
            <path d="M5.25 5.25a3 3 0 0 0-3 3v10.5a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3V13.5a.75.75 0 0 0-1.5 0v5.25a1.5 1.5 0 0 1-1.5 1.5H5.25a1.5 1.5 0 0 1-1.5-1.5V8.25a1.5 1.5 0 0 1 1.5-1.5h5.25a.75.75 0 0 0 0-1.5H5.25Z" />
          </svg>
          )}
        </h2>
        <p className="text-lg font-poppinsLight max-w-[43rem] text-[#717173]">
          {subHeading}
        </p>
      </div>

      {/* Services */}
      <div className="py-[1.75rem] w-[80%] mx-auto flex flex-wrap justify-center gap-8">
        {services.map((service) => (
          <div key={service._id} className="relative">
            {/* Service Card */}
            <ServiceCard
              id={service._id}
              image={service.iconImage}
              title={service.title}
              description={service.description}
              fetchServices={fetchServices}
            />

            {/* Delete Icon */}
            {token && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="absolute top-0 right-0 h-8 w-8 border border-black bg-black rounded-full text-white cursor-pointer"
                onClick={() => handleDelete(service._id)}
              >
                <path
                  fillRule="evenodd"
                  d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
        ))}
      </div>

      {/* Add Service Button */}
      {token && (
        <div className="flex justify-center mt-8">
          <button
            onClick={() => setShowServiceModal(true)}
            className="bg-[#25a182] text-white px-6 py-3 rounded-lg shadow-lg hover:bg-white hover:text-[#25a182] border border-[#25a182] transition-transform duration-300 transform hover:scale-105"
          >
            Add Service
          </button>
        </div>
      )}

      {/* Modal for Editing Main Heading and Subheading */}
      {showHeadingModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-[400px]">
            <h3 className="text-2xl font-semibold mb-4">Edit Main Heading</h3>

            {/* Main Heading */}
            <input
              type="text"
              placeholder="Enter Main Heading"
              value={mainHeading}
              onChange={(e) => setMainHeading(e.target.value)}
              className="p-2 border border-gray-300 rounded w-full mb-4"
            />

            {/* Subheading */}
            <textarea
              placeholder="Enter Subheading"
              value={subHeading}
              onChange={(e) => setSubHeading(e.target.value)}
              className="p-2 border h-28 border-gray-300 rounded w-full mb-4"
            />

            {/* Save and Cancel Buttons */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowHeadingModal(false)}
                className="bg-red-400 text-white px-6 py-2 rounded shadow hover:bg-red-500"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowHeadingModal(false)}
                className="bg-[#25a182] text-white px-6 py-2 rounded shadow hover:bg-[#1f795e]"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Adding New Service */}
      {showServiceModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg p-6 w-[400px]">
            <h3 className="text-2xl font-semibold mb-4">Add New Service</h3>

            {/* Title Input */}
            <input
              type="text"
              placeholder="Enter Service Title"
              value={newService.title}
              onChange={(e) => setNewService({ ...newService, title: e.target.value })}
              className="p-2 border border-gray-300 rounded w-full mb-4"
            />

            {/* description Input */}
            <textarea
              placeholder="Enter Service Description"
              value={newService.description}
              onChange={(e) => setNewService({ ...newService, description: e.target.value })}
              className="p-2 border border-gray-300 rounded w-full mb-4"
            />

            {/* File Input for Image Upload */}
            <input
              type="file"
              accept="image/*"
              onChange={handleFileChange}
              className="p-2 border border-gray-300 rounded w-full mb-4"
            />

            {/* Preview of the uploaded image */}
            {/* {imageFile && <img src={imageFile} alt="Service Preview" className="mb-4 max-h-[200px]" />} */}

            {/* Save and Cancel Buttons */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowServiceModal(false)}
                className="bg-red-400 text-white px-6 py-2 rounded shadow hover:bg-red-500"
              >
                Cancel
              </button>
              <button
                onClick={handleAddService}
                className="bg-[#25a182] text-white px-6 py-2 rounded shadow hover:bg-[#1f795e]"
              >
                Add Service
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OurService;
